import React, { useState/*, useEffect*/  } from 'react';
import { Button, TextField, Box, Typography, Container, Link } from '@mui/material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { getEnv } from "../libs/global";

const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');  // Estado para manejar los errores
  const navigate = useNavigate();
  const envel = getEnv();

  /*const storeInLocalStorage = (key, value) => {
    return new Promise((resolve) => {
      localStorage.setItem(key, value);
      resolve();
    });
  };*/

  localStorage.clear(); // Limpia todo el localStorage
  // useEffect(() => {
  //   const authToken = localStorage.getItem('authToken');
  //   if (authToken) {
  //     // Si encuentra el token, redirige al dashboard
  //     navigate('/dashboard');
  //   }
  // }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Enviar solicitud al backend para autenticar con GET
      const response = await axios.post(`${envel.url}/backComerbasPHP/public/index.php`, {
        action: 'login',
        email,
        password,
      });
      const data = response.data;
      if (data.status === 'success') {
        // Guardar los datos en localStorage y asegurarse de que se complete antes de redirigir
        localStorage.setItem('authToken', '6LeSqQ8pAAAAANhbBHhnToCiwkbbnj7isNTbTqYI');
        localStorage.setItem('conv', data.user.Convenio);
        localStorage.setItem('email', data.user.email);

        const authToken = localStorage.getItem('authToken');
        if (authToken) {
          navigate('/dashboard'); // Redireccionar si el token ya existe
        }
        // Redirigir al dashboard después de asegurarse de que el almacenamiento se completó
        // navigate('/dashboard');
      } else {
        // Si el login falla, mostrar el mensaje de error
        setError(data.message);
      }
    } catch (error) {
      // Capturar cualquier error en la solicitud
      setError('Error en el servidor, intenta más tarde.');
    }
  };
  const handleReset = async (e) =>{
    navigate('/recuperar');
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography component="h1" variant="h5">
          Iniciar Sesión
        </Typography>

        {/* Mostrar el error si existe */}
        {error && (
          <Typography color="error" variant="body2" sx={{ mt: 2 }}>
            {error}
          </Typography>
        )}

        {/* Formulario de inicio de sesión */}
        <Box component="div" sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Correo Electrónico"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Contraseña"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <Button
            // type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={handleSubmit}
          >
            Iniciar Sesión
          </Button>


          
          <Link
            component="button"
            variant="body2"
            onClick={handleReset}
          >
            ¿Olvido su Contraseña?
          </Link>
        </Box>
      </Box>
    </Container>
  );
};

export default LoginForm;
